export const isDevelopment = (): boolean => {
  return process.env.NODE_ENV === "development";
};

export const camelize = (str: string) => {
  const returnStr = str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
    return index === 0 ? word.toUpperCase() : word.toLowerCase();
  });

  return returnStr;
};
